var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement, forwardRef, isValidElement } from 'react';
import { isValidElementType } from 'react-is';
import styled from 'styled-components';
import { responsiveRadiusStyle } from '../../styles/internal';
import { useTheme } from '../../theme';
import { Box } from '../box';
import { Flex } from '../flex';
import { Spinner } from '../spinner';
import { Text } from '../text';
import { buttonBaseStyles, buttonColorStyles } from './styles';
const Root = styled.button(responsiveRadiusStyle, buttonBaseStyles, buttonColorStyles);
const LoadingBox = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--card-bg-color);
  border-radius: inherit;
  z-index: 1;
  box-shadow: inherit;
`;
export const Button = forwardRef((props, ref) => {
    const { children, disabled, fontSize, icon, iconRight, justify = 'center', loading, mode = 'default', padding = 3, paddingX, paddingY, paddingTop, paddingBottom, paddingLeft, paddingRight, radius = 2, selected, space = 3, text, tone = 'default', type = 'button' } = props, restProps = __rest(props, ["children", "disabled", "fontSize", "icon", "iconRight", "justify", "loading", "mode", "padding", "paddingX", "paddingY", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "radius", "selected", "space", "text", "tone", "type"]);
    const theme = useTheme();
    const boxProps = {
        padding,
        paddingX,
        paddingY,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
    };
    return (React.createElement(Root, Object.assign({ "data-ui": "Button" }, restProps, { "$mode": mode, "$radius": radius, "$tone": tone, "data-disabled": Boolean(loading || disabled), "data-selected": selected ? '' : undefined, disabled: Boolean(loading || disabled), ref: ref, type: type }),
        Boolean(loading) && (React.createElement(LoadingBox, null,
            React.createElement(Spinner, null))),
        (icon || text || iconRight) && (React.createElement(Box, Object.assign({ as: "span" }, boxProps),
            React.createElement(Flex, { as: "span", justify: justify },
                icon && (React.createElement(Text, { size: fontSize },
                    isValidElement(icon) && icon,
                    isValidElementType(icon) && createElement(icon))),
                text && (React.createElement(Box, { flex: iconRight ? 1 : undefined, marginLeft: icon ? space : undefined, marginRight: iconRight ? space : undefined },
                    React.createElement(Text, { size: fontSize, weight: theme.sanity.button.textWeight }, text))),
                iconRight && (React.createElement(Text, { size: fontSize },
                    isValidElement(iconRight) && iconRight,
                    isValidElementType(iconRight) && createElement(iconRight)))))),
        children && React.createElement("span", null, children)));
});
Button.displayName = 'Button';
//# sourceMappingURL=button.js.map